var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminarZj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 122,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eliminar-zj_svg__clip0_8771_72017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.009 48.072l9.246 70.333A4.134 4.134 0 0034.352 122h46.484a4.128 4.128 0 004.097-3.595l7.14-54.302 2.72-20.68H25.654l-4.645 4.649z",
    fill: "#6089F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.462 59.967v45.49a4.133 4.133 0 108.267 0v-45.49a4.133 4.133 0 10-8.267 0zM36.929 59.967v45.49a4.133 4.133 0 108.267 0v-45.49a4.133 4.133 0 10-8.267 0zM69.996 59.967v45.49a4.133 4.133 0 108.267 0v-45.49a4.133 4.133 0 10-8.267 0z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.462 31.017l8.267 4.135h10.332l-4.134-10.337-8.266-2.066-6.199 8.268z",
    fill: "#FF652B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.663 16.543L80.332 18.61v4.136l2.064 8.271 16.534-2.065-6.198-8.272-2.069-4.136z",
    fill: "#FE3A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.82 3.55a4.132 4.132 0 00-5.844 0L1.21 50.337a4.137 4.137 0 000 5.848l5.845 5.848L59.665 9.398 53.82 3.55z",
    fill: "#6089F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.321 14.416L3.394 58.37l3.662 3.664L59.665 9.398 53.82 3.55a4.132 4.132 0 00-5.844 0l-.65.65a7.22 7.22 0 01-.005 10.216z",
    fill: "#2063C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.728 20.679l-2.064-4.136-3.756.753 1.69 3.383 6.199 8.272-12.526 1.565.126.5 16.533-2.065-6.202-8.272z",
    fill: "#FFA15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.794 26.88l3.309 8.272h4.958l-4.133-10.337-8.267-2.066-1.96 2.61 6.093 1.522z",
    fill: "#FF8A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 38.637L8.52 34.254a6.21 6.21 0 010-8.772L23.13 10.858c2.414-2.42 6.349-2.42 8.767 0l4.381 4.384-2.922 2.924-4.377-4.384a2.07 2.07 0 00-2.922 0L11.44 28.402a2.072 2.072 0 000 2.924l4.381 4.383-2.922 2.928z",
    fill: "#6089F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.397 0h4.133v4.136h-4.133V0z",
    fill: "#FFA15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.109 16.116l-2.52-3.278A24.099 24.099 0 01120 8.312l-.808 4.055a19.97 19.97 0 00-16.083 3.75zM109.263 20.679h4.133v4.136h-4.133v-4.136z",
    fill: "#FF652B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.797 10.338h-4.133C90.664 4.64 95.297 0 100.996 0v4.136a6.206 6.206 0 00-6.199 6.202z",
    fill: "#FF8A5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eliminar-zj_svg__clip0_8771_72017"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/eliminar-zj.f2db144b.svg";
export { SvgEliminarZj as ReactComponent };